import { Component, Input, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { Tag } from 'src/app/shared/models/general/tag';
import { TagsService } from 'src/app/services/tags.service';

@Component({
  selector: 'app-tags-editor',
  templateUrl: './tags-editor.component.html',
  styleUrls: ['./tags-editor.component.scss'],
})
export class TagsEditorComponent implements OnInit, OnChanges {
  @Input() UserId: number;
  @Output() TagEditError = new EventEmitter<any>();

  allTags: Tag[] = [];
  activeUserTags: Tag[] = [];
  tagSaveFailed: boolean = false;

  constructor(private tagsService: TagsService) {}

  ngOnInit(): void {}

  ngOnChanges(): void {
    this.getUserTags();
  }

  isTagDisplayable(tag: Tag): boolean {
    if (tag.name.toLocaleLowerCase() === 'withdrawal') {
      return false;
    }

    if (tag.name.toLocaleLowerCase() === 'trade for sars') {
      return false;
    }

    return true;
  }

  saveTags(tag: Tag) {
    this.tagSaveFailed = false;
    this.tagsService.UpsertUserTags(tag).subscribe({
      next: () => {
        tag.recentlyUpdated = true;
        setTimeout(() => {
          tag.recentlyUpdated = false;
        }, 1000);
      },
      error: (err) => {
        this.tagSaveFailed = true;
        this.emitError(err);
      },
    });
  }

  getUserTags() {
    if (this.UserId) {
      this.tagsService.GetUserTags(this.UserId, true).subscribe({
        next: (activeTags: Tag[]) => {
          this.activeUserTags = activeTags;
          this.markActiveTags();
        },
        error: (err) => {
          this.emitError(err);
        },
      });
    } else {
      this.tagsService.GetNonSystemTags().subscribe({
        next: (allTags: Tag[]) => {
          this.allTags = allTags;
        },
        error: (err) => {
          this.emitError(err);
        },
      });
    }
  }

  markActiveTags() {
    //generate a flat list of ids that are active
    const activeTagIds = this.activeUserTags.map((tag) => {
      if (tag.active) {
        return tag.id;
      }
    });
    //foreach available tag set the active property to true if the id is in the activeTagId list
    this.allTags.forEach((tag) => {
      tag.userId = this.UserId; //set the user id so we know who to save against
      tag.active = activeTagIds.includes(tag.id);
    });
    //force the ui to realise this is a new array and redraw
    this.allTags = [...this.allTags];
  }

  displayableTags(): Tag[] {
    return this.allTags.filter((tag) => this.isTagDisplayable(tag));
  }

  emitError(error: any) {
    //emit error for handling by the parent
    this.TagEditError.emit(error);
  }
}
